import type { PoseCelda, TestConfigPayload } from './tipos';

/**
 * Body de generación de una celda del test masivo — contrato adBody REAL de
 * atlas-backend/src/routes/ads.ts. La regla: nunca mandar keys sin valor
 * (el zod es .optional(), no .nullish(), en casi todos los campos), y cada
 * campo viaja SOLO en el modo al que pertenece — igual que la UI real.
 * `buildTestBody.test.ts` fija el contrato por deep-equal.
 */
export function buildTestBody(
  payload: TestConfigPayload,
  varianteId: string,
  executionId: string,
  /** Pose de ESTA celda (la expansión por pose vive en celdas.ts). Null = default. */
  pose: PoseCelda = null,
): Record<string, unknown> {
  const body: Record<string, unknown> = {
    execution_id: executionId,
    modo: 'personalizado',
    modo_utilizado: 'test_masivo',
    variante_id: varianteId,
    mode: 'single',
    cantidad_imagenes: 1,
    formato: payload.formato,
    composicion: payload.composicion,
    modo_pro: true,
    guardar_como_imagen_generada: true,
  };

  if (payload.composicion === 'modelo') {
    if (payload.modelo_mode) body.modelo_mode = payload.modelo_mode;
    if (payload.modelo_mode === 'guardados' && payload.modelo_guardado_id) {
      body.modelo_guardado_id = payload.modelo_guardado_id;
    }
    if (payload.modelo_mode === 'personalizado') {
      for (const k of ['genero', 'edad', 'tipo_cuerpo', 'tono_piel', 'color_pelo', 'largo_pelo', 'desc_modelo'] as const) {
        const v = payload[k];
        if (v) body[k] = v;
      }
    }
    if (pose?.tipo === 'catalogo') body.pose = [pose.id];
    if (pose?.tipo === 'custom') body.poses_custom = [{ id: pose.id, filename: pose.filename }];
  } else if (payload.vista_producto) {
    body.vista_producto = payload.vista_producto;
  }

  body.background_mode = payload.background_mode;
  if (payload.background_mode === 'blanco' || payload.background_mode === 'elegido') {
    if (payload.background_id != null) body.background_id = payload.background_id;
  } else if (payload.background_mode === 'descripcion') {
    if (payload.background_text) body.background_text = payload.background_text;
  } else if (payload.background_mode === 'guardado') {
    if (payload.background_file_name) body.background_file_name = payload.background_file_name;
  }
  if (payload.composicion === 'modelo' && payload.background_mode === 'blanco') {
    if (payload.fondo_blanco_iluminacion) body.fondo_blanco_iluminacion = payload.fondo_blanco_iluminacion;
    if (payload.fondo_blanco_temperatura) body.fondo_blanco_temperatura = payload.fondo_blanco_temperatura;
  }

  if (payload.instruccion_adicional) body.instruccion_adicional = payload.instruccion_adicional;
  if (payload.provider_override) body.provider_override = payload.provider_override;
  return body;
}
